<template>
    <Card :title="$t('labels.supplier')">
        <div class="card-body">
            <FormGroup :label="$t('labels.name')">
                <Input
                    v-model="supplier.name"
                />
            </FormGroup>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../../components/new/CardComponent.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
export default {
    name: "SupplierCard",
    components: {
        Card, FormGroup, Input
    },
    props: {
        supplier: {
            type: Object,
            required: true
        }
    }
}
</script>
